import _ from 'lodash';

import { MediaAsset, UploadFileSuccessPayload } from '../../types/media-assets';
import { StringMap } from '../../types/system';
import { normalizeFile } from '../../utils/media-assets/media-assets';
import { FILE_MANAGER_COMPONENT_ACTIONS } from '../file-manager-component/file-manager-component.actions';
import { JobEventPayload, JOBS_ACTION_NAMES } from '../jobs/jobs.actions';
import { JobStatus, JobTypes } from '../jobs/jobs.types';
import { Action } from '../redux.types';
import { FILES_ACTIONS } from './files.actions';

export type FilesState = StringMap<MediaAsset>;

const defaultState: FilesState = {};

/**
 * All files ever loaded to file manager
 * Never delete file from this reducer! Because some part of the system may still have reference to it
 */
export const files = (
  state: FilesState = defaultState,
  { type, payload }: Action,
): FilesState => {
  switch (type) {
    case FILE_MANAGER_COMPONENT_ACTIONS.FILES_LIST_GET_SUCCESS:
    case FILE_MANAGER_COMPONENT_ACTIONS.FILES_LIST_LOAD_MORE_SUCCESS:
      return {
        ...state,
        ..._.keyBy(payload.files, 'id'),
      };

    case FILES_ACTIONS.FOLDER_CREATE_SUCCESS:
      return {
        ...state,
        [payload.id]: payload,
      };

    case FILES_ACTIONS.FILE_UPLOAD_SUCCESS:
    case FILES_ACTIONS.FILE_CREATE: {
      const { file }: UploadFileSuccessPayload = payload;
      return {
        ...state,
        [file.id]: file,
      };
    }
    case FILES_ACTIONS.FILE_DELETE_SUCCESS:
      return _.omit(state, payload.id);

    case FILES_ACTIONS.FILE_ACL_UPDATE_SUCCESS:
      return {
        ...state,
        [payload.id]: normalizeFile(payload),
      };

    case JOBS_ACTION_NAMES.JOB_STATUS_CHANGED: {
      const { job }: JobEventPayload<any> = payload;

      if (job.status !== JobStatus.SUCCESS || !job.result) {
        return state;
      }

      switch (job.type) {
        case JobTypes.ArchiveCreate:
          return {
            ...state,
            [job.result.payload.id]: normalizeFile(job.result.payload),
          };

        default:
          return state;
      }
    }

    default:
      return state;
  }
};
